'use client';
import Link from 'next/link';
import { SettingsIcon } from 'lucide-react';
import { Show } from '@clerk/nextjs';

import cn from 'classnames';
import { buttonVariants } from '@rocket-house-productions/shadcn-ui/server';
import Image, { type StaticImageData } from 'next/image';
import React from 'react';
import { UserSignedInDropdown } from '@rocket-house-productions/features';

interface HeaderProps {
  isAdmin?: boolean;
  logo?: StaticImageData | null;
  purchaseType?: string | null;
  purchaseCategory?: string | null;
  backToUrl?: string;
  backToText?: string;
  classNames?: string;
}

export function NavbarSimple({
  isAdmin = false,
  logo = null,
  backToUrl = '/',
  backToText = 'Back to home',
  classNames,
}: HeaderProps) {
  return (
    <div
      id="navbar"
      className={cn('navbar-area fixed z-50 bg-transparent px-5 py-[20px] lg:py-[25px] xl:py-4', classNames)}>
      <div className="container mx-auto max-w-[1266px]">
        <nav className={`navbar relative flex flex-wrap items-center justify-between`}>
          <div className="self-center">
            {logo && (
              <Link href={backToUrl}>
                <Image src={logo} className="inline" alt="logo" />
                <span className={'sr-only'}>{backToText}</span>
              </Link>
            )}
            {!logo && (
              <Link href={backToUrl} className={buttonVariants({ variant: 'lesson' })}>
                <span>{backToText}</span>
              </Link>
            )}
          </div>
          {/* Other options */}
          <div className="other-options block self-center pb-[10px] pt-[20px] xl:ml-[20px] xl:pb-[0] xl:pt-[0] 2xl:ml-[15px]">
            <ul className={'flex flex-row items-center justify-center space-x-2'}>
              <li className="flex items-center justify-center">
                <Show when="signed-out">
                  <Link href="/sign-in" className={cn(buttonVariants({ variant: 'link' }), '!text-[16px] font-medium')}>
                    Log in
                  </Link>
                </Show>
                <UserSignedInDropdown />
              </li>
              <li>
                <Show when="signed-out">
                  <Link
                    href="/sign-up"
                    className={cn(buttonVariants({ variant: 'default', size: 'sm' }), '!text-[14px] uppercase')}>
                    Buy now
                  </Link>
                </Show>
                <Show when="signed-in">
                  <div className={'flex space-x-1'}>
                    {isAdmin && (
                      <Link href="/admin" className={buttonVariants({ variant: 'default' })}>
                        <i>
                          <SettingsIcon className={'h-4 w-4'} />{' '}
                        </i>
                        Admin
                      </Link>
                    )}
                  </div>
                </Show>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}
